import { getFileUrl, AVATAR_SIZE } from '../../../lib/file';
import defaultAvatar from '../../../images/default-avatar.png';

export const getAvatar = (avatar) => {
	if (!avatar) return defaultAvatar;
	return getFileUrl({ name: avatar }, AVATAR_SIZE.width, AVATAR_SIZE.height);
};
